import { render, staticRenderFns } from "./LogoView.vue?vue&type=template&id=074bf3ca&scoped=true"
import script from "./LogoView.vue?vue&type=script&lang=js"
export * from "./LogoView.vue?vue&type=script&lang=js"
import style0 from "./LogoView.vue?vue&type=style&index=0&id=074bf3ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074bf3ca",
  null
  
)

export default component.exports